import React from "react";
import "./WhaleDolphinStats.scss";
import utils from "../../../../../helpers/utils";
import { WhaleDolphinConfig } from "../../WildLifeTourismConfig";
import LargeStat from "../../../../Stats/LargeStat";
import SmallStat from "../../../../Stats/SmallStat";
import { Grid } from "@material-ui/core";

function WhaleDolphinStats(props) {
  const { stats, selectedGeometry } = props;

  /**
   * Full stats are full width
   */
  const fullStats = WhaleDolphinConfig.stats.large;

  /**
   * short stats are half width
   */
  const shortStats = WhaleDolphinConfig.stats.small;

  const country = utils.getCountryAttrForSelectedGeometry(
    selectedGeometry
  );

  return (
    <div className="whaleDolphinStats">
      {Object.keys(stats).length > 0 && (
        <>
         <Grid container className="short-stat-container">
            {shortStats.map((item) => (
              <SmallStat
                key={item.name}
                size={6}
                item={item}
                stats={stats}
                country={country}
              />
            ))}
          </Grid>
        {fullStats.map((item) => (
          <LargeStat
            key={item.name}
            item={item}
            stats={stats}
            country={country}
          />
        ))}
      </>
      )}
    </div>
  );
}

export default WhaleDolphinStats;
